import React, { memo } from "react";
import { ReactComponent as ChatIcon } from "../../../../../../assets/images/ChatIcon.svg";

import IconButton from "../../../../../../components/UI/IconButton";

import { openChat } from "../../../../../../utils/providers";
import { useShopifyApp } from "../../../../../../hooks/useShopifyApp";

import { Container } from "./styles";

const GetAssistanceButton = ({ title }) => {
  const isShopifyApp = useShopifyApp();

  return (
    <Container>
      <IconButton
        title={title || "Get Help"}
        icon={<ChatIcon />}
        onClick={() => openChat()}
        variant={isShopifyApp ? "secondary" : "blue"}
        iconSize="14px"
      />
    </Container>
  );
};

export default memo(GetAssistanceButton);
